module.exports = __webpack_public_path__ + "img/article-image-2.7ffac9a2.jpeg";